import { useEffect, useRef } from 'react'

import noop from 'lib/function/noop'
import { useChatStreamStatus } from 'tripPlanner/assistant/contexts/ChatStreamStatusContext'

interface Props {
  handoffChatId: number | undefined
  refetchChatList: () => Promise<unknown>
}

/** svc-trip names a handoff chat while its first turn runs, and only a list refetch carries that name to the side nav. */
function RefreshChatListAfterHandoffTurn({ handoffChatId, refetchChatList }: Props) {
  const { chatId, isStreaming } = useChatStreamStatus()
  const wasStreamingRef = useRef(false)
  const hasRefreshedRef = useRef(false)

  useEffect(() => {
    if (handoffChatId === undefined || chatId !== handoffChatId || hasRefreshedRef.current) return
    if (isStreaming) {
      wasStreamingRef.current = true
      return
    }
    if (!wasStreamingRef.current) return
    hasRefreshedRef.current = true
    refetchChatList().catch(noop)
  }, [chatId, handoffChatId, isStreaming, refetchChatList])

  return null
}

export default RefreshChatListAfterHandoffTurn
